/**
 * Generated from ch5_p10.fla
 */
export function ch5_p10(this: Ich5_p10) {
	const balloonPink = this.balloonPink;
	if (!balloonPink[0] && balloonPink.elementFactory) {
		balloonPink[0] = balloonPink.elementFactory(0,undefined);
	}
	if (balloonPink[0]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1.call(balloonPink[0] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1);
		balloonPink[0].x = 937.25;
		balloonPink[0].y = 552.5;
		balloonPink[0].width = 408.50;
		balloonPink[0].height = 431.00;
		balloonPink[0].alpha = 1;
		if (balloonPink[0].onLayout) balloonPink[0].onLayout();
	}
	if (!balloonPink[1] && balloonPink.elementFactory) {
		balloonPink[1] = balloonPink.elementFactory(1,undefined);
	}
	if (balloonPink[1]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2.call(balloonPink[1] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2);
		balloonPink[1].x = 913.25;
		balloonPink[1].y = 502.5;
		balloonPink[1].width = 386.50;
		balloonPink[1].height = 531.00;
		balloonPink[1].alpha = 1;
		if (balloonPink[1].onLayout) balloonPink[1].onLayout();
	}
	const treeFront = this.treeFront;
	if (!treeFront[0] && treeFront.elementFactory) {
		treeFront[0] = treeFront.elementFactory(0,undefined);
	}
	if (treeFront[0]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1.call(treeFront[0] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1);
		treeFront[0].x = 832;
		treeFront[0].y = 384;
		treeFront[0].width = 1664.00;
		treeFront[0].height = 768.00;
		treeFront[0].alpha = 1;
		if (treeFront[0].onLayout) treeFront[0].onLayout();
	}
	if (!treeFront[1] && treeFront.elementFactory) {
		treeFront[1] = treeFront.elementFactory(1,undefined);
	}
	if (treeFront[1]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2.call(treeFront[1] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2);
		treeFront[1].x = 790.25;
		treeFront[1].y = 384;
		treeFront[1].width = 1580.50;
		treeFront[1].height = 768.00;
		treeFront[1].alpha = 1;
		if (treeFront[1].onLayout) treeFront[1].onLayout();
	}
	const balloonYellow = this.balloonYellow;
	if (!balloonYellow[0] && balloonYellow.elementFactory) {
		balloonYellow[0] = balloonYellow.elementFactory(0,undefined);
	}
	if (balloonYellow[0]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1.call(balloonYellow[0] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1);
		balloonYellow[0].x = 1515;
		balloonYellow[0].y = 523.75;
		balloonYellow[0].width = 298.00;
		balloonYellow[0].height = 488.50;
		balloonYellow[0].alpha = 1;
		if (balloonYellow[0].onLayout) balloonYellow[0].onLayout();
	}
	if (!balloonYellow[1] && balloonYellow.elementFactory) {
		balloonYellow[1] = balloonYellow.elementFactory(1,undefined);
	}
	if (balloonYellow[1]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2.call(balloonYellow[1] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2);
		balloonYellow[1].x = 1374.25;
		balloonYellow[1].y = 384;
		balloonYellow[1].width = 385.50;
		balloonYellow[1].height = 768.00;
		balloonYellow[1].alpha = 1;
		if (balloonYellow[1].onLayout) balloonYellow[1].onLayout();
	}
	const balloonRed = this.balloonRed;
	if (!balloonRed[0] && balloonRed.elementFactory) {
		balloonRed[0] = balloonRed.elementFactory(0,undefined);
	}
	if (balloonRed[0]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1.call(balloonRed[0] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1);
		balloonRed[0].x = 1401.75;
		balloonRed[0].y = 608;
		balloonRed[0].width = 342.50;
		balloonRed[0].height = 320.00;
		balloonRed[0].alpha = 1;
		if (balloonRed[0].onLayout) balloonRed[0].onLayout();
	}
	if (!balloonRed[1] && balloonRed.elementFactory) {
		balloonRed[1] = balloonRed.elementFactory(1,undefined);
	}
	if (balloonRed[1]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2.call(balloonRed[1] as Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2);
		balloonRed[1].x = 1164.25;
		balloonRed[1].y = 569.75;
		balloonRed[1].width = 342.50;
		balloonRed[1].height = 396.50;
		balloonRed[1].alpha = 1;
		if (balloonRed[1].onLayout) balloonRed[1].onLayout();
	}
	const piece = this.piece;
	if (!piece[0] && piece.elementFactory) {
		piece[0] = piece.elementFactory(0,undefined);
	}
	if (piece[0]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1.call(piece[0] as Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1);
		piece[0].x = 490.75;
		piece[0].y = 684.25;
		piece[0].width = 244.50;
		piece[0].height = 167.50;
		piece[0].alpha = 1;
		if (piece[0].onLayout) piece[0].onLayout();
	}
	if (!piece[1] && piece.elementFactory) {
		piece[1] = piece.elementFactory(1,undefined);
	}
	if (piece[1]) {
		ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2.call(piece[1] as Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2);
		piece[1].x = 772;
		piece[1].y = 68.75;
		piece[1].width = 135.00;
		piece[1].height = 137.50;
		piece[1].alpha = 1;
		if (piece[1].onLayout) piece[1].onLayout();
	}
	const bg = this.bg;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const treeBack = this.treeBack;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treeback.call(this.treeBack);
	treeBack.x = 1169;
	treeBack.y = 666.75;
	treeBack.width = 902.00;
	treeBack.height = 202.50;
	treeBack.alpha = 1.00;
	if (treeBack.onLayout) treeBack.onLayout();
	const branch = this.branch;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_branch.call(this.branch);
	branch.x = 0;
	branch.y = 768;
	branch.width = 1248.50;
	branch.height = 768.00;
	branch.alpha = 1.00;
	if (branch.onLayout) branch.onLayout();
	const bird = this.bird;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bird.call(this.bird);
	bird.x = 738.25;
	bird.y = 166.5;
	bird.width = 148.50;
	bird.height = 112.00;
	bird.alpha = 1.00;
	if (bird.onLayout) bird.onLayout();
	const frameRight = this.frameRight;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 768;
	linesRight.width = 82.00;
	linesRight.height = 451.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 618.25;
	linesLeft.width = 116.50;
	linesLeft.height = 221.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	const popBack = this.popBack;
	ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popback.call(this.popBack);
	popBack.x = 802;
	popBack.y = 391.75;
	popBack.width = 1019.00;
	popBack.height = 631.50;
	popBack.alpha = 1.00;
	if (popBack.onLayout) popBack.onLayout();
	const popFront = this.popFront;
	ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popfront.call(this.popFront);
	popFront.x = 852.25;
	popFront.y = 380;
	popFront.width = 1018.50;
	popFront.height = 608.00;
	popFront.alpha = 1.00;
	if (popFront.onLayout) popFront.onLayout();
	const pop = this.pop;
	ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_pop.call(this.pop);
	pop.x = 785.75;
	pop.y = 356.25;
	pop.width = 480.50;
	pop.height = 309.50;
	pop.alpha = 1.00;
	if (pop.onLayout) pop.onLayout();
	const actionLines = this.actionLines;
	ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_actionlines.call(this.actionLines);
	actionLines.x = 832;
	actionLines.y = 384;
	actionLines.width = 1664.00;
	actionLines.height = 768.00;
	actionLines.alpha = 1.00;
	if (actionLines.onLayout) actionLines.onLayout();
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bg(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treeback(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treeback) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_treeback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloonp2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_branch(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_branch) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_branch", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bird(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bird) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_bird", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_treefront2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_treefront1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloony1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloonr1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloonp1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloony2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_balloonr2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeRframe(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframerlines(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeLframe(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframellines(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popback(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popback) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_popback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popfront(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_popfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_pop(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_pop) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_pop", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_actionlines(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_actionlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_actionlines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_piece1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2(this: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p10_piece2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p10Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p10Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p10Sprite extends Ich5_p10Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p10Text extends Ich5_p10Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p10Polygon extends Array<number> {
}
interface Ich5_p10 {
	readonly balloonPink: Ich5_p10Array<Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1|Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2>;
	readonly treeFront: Ich5_p10Array<Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1|Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2>;
	readonly balloonYellow: Ich5_p10Array<Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1|Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2>;
	readonly balloonRed: Ich5_p10Array<Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1|Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2>;
	readonly piece: Ich5_p10Array<Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1|Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2>;
	readonly bg: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bg;
	readonly treeBack: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treeback;
	readonly branch: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_branch;
	readonly bird: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bird;
	readonly frameRight: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeRframe;
	readonly linesRight: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframerlines;
	readonly frameLeft: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeLframe;
	readonly linesLeft: Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframellines;
	readonly popBack: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popback;
	readonly popFront: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popfront;
	readonly pop: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_pop;
	readonly actionLines: Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_actionlines;
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bg extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treeback extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp2 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_branch extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_bird extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront2 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_treefront1 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony1 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr1 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonp1 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloony2 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_balloonr2 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeRframe extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframerlines extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframeLframe extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetch5_p10_wcframellines extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popback extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_popfront extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_pop extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_actionlines extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece1 extends Ich5_p10Sprite {
}
interface Ich5_p10_hh_ch5_72dpi_p010psdAssetPOPch5_p10_piece2 extends Ich5_p10Sprite {
}
